import { registerI18n } from '@videojs/cdn/i18n-registry';
import translations from '@videojs/core/i18n/locales/es';

registerI18n('es', translations);
